import { actions } from '@signalwire/core'

export const audioSetSpeakerAction = actions.createAction<string>(
  'swJs/audioSetSpeakerAction'
)
